import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Input, Select } from "antd";
import { updateSelectedResourceWidgetName } from "../../../../../redux/editorSlice";
import "./RestApiSelector.css";
import { SwapOutlined } from "@ant-design/icons";

const { Option } = Select;

export default function RestApiSelector(props) {
  console.log("props", props);
  const dispatch = useDispatch();
  const [apiList, setApiList] = useState([]);

  /* The widget name lives on the resource's SOURCE - that is what the reducer writes,
     what the canvas card title reads, and what gets saved with the board.
     Read it from THIS block's resource. It used to come from the globally selected
     resource, so with several blocks on screen every one of them displayed the active
     resource's name and appeared to change as you typed in another. */
  const selectedWidget = props.selectedResource?.source?.widgetName || "";

  /* Same test the rest of the editor uses - anything that is not a report is treated
     as a dashboard, so a missing config keeps the field visible rather than hiding it. */
  const isReport = props?.dashboardConfig?.boardType === "reports";

  useEffect(() => {
    if (props.connections && props.dashboardConfig) {
      if (props.dashboardConfig.isGlobal === true) {
        setApiList(
          props.connections
            .filter((c) => c.isWitmegApi && c.visibleTo === "global")
            .sort((a, b) => (a.name < b.name ? -1 : a.name > b.name ? 1 : 0)),
        );
      } else {
        setApiList(props.connections.sort((a, b) => (a.name < b.name ? -1 : a.name > b.name ? 1 : 0)));
      }
    }
  }, [props]);

  const handleConnectionChange = (resId) => {
    return props.getSelectedConnection(resId);
  };

  const onHandleWidgetNameChange = (e) => {
    const widgetName = e.target.value;
    dispatch(updateSelectedResourceWidgetName({ id: props.selectedResource.id, widgetName }));
  };

  console.log(
    "apiList",
    props.connections
      .filter((c) => c.isWitmegApi && c.visibleTo === "global")
      .sort((a, b) => (a.name < b.name ? -1 : a.name > b.name ? 1 : 0)),
  );
  return (
    <>
      <div className="rest-api-selector">
        <div className="rest-api-selector-field">
          <label>Resource</label>
          <Select
            value={props.selectedResource?.source?.id || ""}
            onChange={(e) => handleConnectionChange(e)}
            showSearch
            filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            dropdownStyle={{ maxHeight: 300, overflow: "auto" }}
            virtual={false}
            getPopupContainer={() => document.body}
          >
            {apiList.length &&
              apiList.map((con) => (
                <Option key={"m_i_" + con.name} value={con.id}>
                  {con.name}
                </Option>
              ))}
          </Select>
        </div>
        <div className="rest-api-selector-grid">
          {/* Names the widget on the canvas (and the CSV export). Dashboards only - a
              report already carries its own name onto the widget, so asking for a
              second one here just duplicates it. */}
          {!isReport && (
            <div className="rest-api-selector-field">
              <label>Widget Name</label>
              <Input
                value={selectedWidget}
                placeholder="Enter the widget name.."
                onChange={(e) => onHandleWidgetNameChange(e)}
                className="editor-input"
                disabled={!props.selectedResource?.source?.id}
              />
            </div>
          )}

          <div className="rest-api-selector-field rest-api-selector-full">
            <label>API URL</label>
            <Input
              readOnly
              value={props.selectedResource?.source?.connectionData?.baseUrl}
              title={props.selectedResource?.source?.connectionData?.baseUrl}
            />
          </div>
        </div>
      </div>
    </>
  );

  // return (
  //   <div className="rest-api-selector">

  //     {/* Row 1: API Type + Resource */}
  //     <div className="rest-api-selector-grid">
  //       <div className="rest-api-selector-field">
  //         <label>API Type</label>
  //         <Select
  //           value={props.selectedResource?.type || undefined}
  //           placeholder="Select type"
  //           onChange={(val) => props.onApiTypeSelect && props.onApiTypeSelect(val)}
  //         >
  //           <Option value="Rest API">REST API</Option>
  //           <Option value="Combined Resource">Combined Resource</Option>
  //         </Select>
  //       </div>

  //       <div className="rest-api-selector-field">
  //         <label>Resource</label>
  //         <Select
  //           value={props.selectedResource?.source?.id || undefined}
  //           placeholder="Select"
  //           onChange={(e) => handleConnectionChange(e)}
  //           showSearch
  //           filterOption={(input, option) =>
  //             option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
  //           }
  //           dropdownStyle={{ maxHeight: 300, overflow: "auto" }}
  //           virtual={false}
  //           getPopupContainer={() => document.body}
  //         >
  //           {apiList.length &&
  //             apiList.map((con) => (
  //               <Option key={"m_i_" + con.name} value={con.id}>
  //                 {con.name}
  //               </Option>
  //             ))}
  //         </Select>
  //       </div>
  //     </div>

  //     {/* Widget Name — only for dashboard type */}
  //     {props?.dashboardConfig?.boardType === "dashboard" ? (
  //       <div className="rest-api-selector-field">
  //         <label>Widget Name</label>
  //         <Input
  //           value={selectedWidget}
  //           placeholder="Enter the widget name.."
  //           onChange={(e) => onHandleWidgetNameChange(e)}
  //         />
  //       </div>
  //     ) : null}

  //     {/* API URL — only after resource selected */}
  //     {props.selectedResource?.source?.connectionData?.baseUrl ? (
  //       <div className="rest-api-selector-field rest-api-selector-full">
  //         <label>API URL</label>
  //         <Input
  //           readOnly
  //           value={props.selectedResource?.source?.connectionData?.baseUrl}
  //           title={props.selectedResource?.source?.connectionData?.baseUrl}
  //         />
  //       </div>
  //     ) : null}

  //   </div>
  // );
}
